export default "__VITE_ASSET__CxrF4pEN__"